// eslint-disable-next-line import/prefer-default-export
export const tours = [
    { name: '/home', url: 'https://phox.pharmaguide.ca/home?product_tour_id=293050' },
    { name: '/patientforms', url: 'https://phox.pharmaguide.ca/patientforms?product_tour_id=293077' },
    { name: '/patient/form/adapt', url: 'https://phox.pharmaguide.ca/patient/form/adapt?product_tour_id=299172' },
    { name: '/Template', url: 'https://phox-dev.pharmaguide.ca/Template?product_tour_id=310686' },
]